import React, { Component } from 'react'
import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'

const DotButton = styled.button`
  height: ${SIZES.medium};
  width: ${SIZES.large};
  cursor: pointer;
  border: 0;
  background: none;
  padding: 0;

  &:focus {
    outline: 0;
  }
`

const DotInner = styled.div<{ active: boolean }>(
  ({ theme, active }) => `
  background-color: ${
    active ? theme.palette.action.active : theme.palette.action.disabled
  };
  height: ${SIZES.xs};
  width: ${SIZES.xs};
  border-radius: 50%;
  margin: 3px;
`,
)

interface Props {
  onClick(event: React.MouseEvent, index: number): void
  active: boolean
  index: number
}

class PaginationDot extends Component<Props> {
  handleClick = (event: React.MouseEvent) => {
    this.props.onClick(event, this.props.index)
  }

  override render() {
    const { active } = this.props

    return (
      <DotButton onClick={this.handleClick}>
        <DotInner active={active} />
      </DotButton>
    )
  }
}

export default PaginationDot
